import axios from './request'
/**
 * 获取城市ID，城市名称等数据
 * @param {Object} params 定位位置(非必传)
 */
export function geocoder(params) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/h5web/bingo/h5/city/geocoder', {
  // return axios.post('https://pwa.tujia.com/feapi/h5web/bingo/h5/city/geocoder', {
    ...params
  })
}

/**
 * m站接口获取城市id，城市名称
 */
export function geoData({ coordType, latitude, longitude }) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/m/bingo/h5/city/geocoder', { data: arguments[0] })
  // return axios.post('https://pwa.tujia.com/feapi/m/bingo/h5/city/geocoder', { data: arguments[0] })
}

/**
 * pwa获取热门城市，城市列表接口
 */
export function getCity() {
  return axios.post('/bnbapp-node-h5/h5/city/bnb', { data: arguments[0] })
  // return axios.post('https://pwa.tujia.com/bnbapp-node-h5/h5/city/bnb', { data: arguments[0] })
}
